<template>
  <div>
    <div class="row" v-for="warehouse in productVariationsWarehouses" :key="warehouse.warehouse.id">
      <div class="col-sm-12">
        <transition name="el-fade-in-linear">
          <div>
            <h5>{{ warehouse.warehouse.name }}</h5>
            <table class="table">
              <thead>
                <tr>
                  <th>Variation</th>
                  <th class="text-center">Menge</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="stockRotation in warehouse.stockRotations" :key="stockRotation.product_instance_id">
                  <td>
                    {{ stockRotation.product_instance.product.stringRepShort.join(' | ') }}
                  </td>
                  <td class="text-right" v-text="stockRotation.quantity"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </transition>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['productVariationsWarehouses']
}
</script>

<style>
</style>
